module.exports = __webpack_public_path__ + "media/bootstrap-icons/tablet-landscape-87f2042d.svg";